export default __webpack_public_path__ + "assets/svg/Dumbbell.d3fb053a6bec41888b5d8488b621ac2f.svg";